import { gql } from "graphql-tag";
import { gameFields, gameFieldsAaa } from "../fragments/game";

export const gamesGQL = gql`
  ${gameFields}
  query Games($input: ListGamesInput!) {
    games(input: $input) {
      total
      status
      items {
        ...GameFields
      }
    }
  }
`;

export const gameGQL = gql`
  ${gameFields}
  query Game($gameId: String!) {
    game(id: $gameId) {
      ...GameFields
    }
  }
`;

export const gameHasPlayedGQL = gql`
  query GameHasPlayed($gameId: String!) {
    game(id: $gameId) {
      id
      hasPlayed
    }
  }
`;

export const gamesPackGQL = gql`
  ${gameFieldsAaa}
  query Games($input: ListGamesInput!) {
    games(input: $input) {
      total
      items {
        ...GameFieldsAaa
      }
    }
  }
`;

export const gamesAaaGQL = gql`
  ${gameFieldsAaa}
  query Games($input: ListGamesInput!) {
    games(input: $input) {
      total
      status
      items {
        ...GameFieldsAaa
      }
    }
  }
`;

export const gameAaaGQL = gql`
  ${gameFieldsAaa}
  query Game($gameId: String!) {
    game(id: $gameId) {
      ...GameFieldsAaa
    }
  }
`;

export const gameSessionGql = gql`
  query GameSession($input: GameSessionInput!) {
    gameSession(input: $input) {
      id
      status
      launchData {
        ... on CasualHtmlLaunchData {
          __typename
          gameConfig
          launchUrl
        }
        ... on N2IStreamLaunchData {
          __typename
          launchUrl
          sessionId
        }
        ... on PCStreamLaunchData {
          __typename
          launchUrl
          streamStatusUrl
        }
        ... on BlacknutStreamLaunchData {
          __typename
          accessToken
          blacknutGameId
          refreshToken
        }
      }
    }
  }
`;

export const gameSessionLowEndDeviceGql = gql`
  query GameSessionLowEndDevice(
    $input: GameSessionInput!
    $deviceInfo: DeviceInfoInput!
  ) {
    gameSession(input: $input) {
      id
      isLowEndDevice(deviceInfo: $deviceInfo)
    }
  }
`;

export const gameQueueStatusGQL = gql`
  query GameQueueStatus {
    gameQueueStatus {
      status
      gameQueue {
        length
        position
        waitTimeSeconds
      }
      game {
        id
        metadata
      }
    }
  }
`;

export const gameInstallationProgressGQL = gql`
  query GameInstallationProgress($input: GameSessionInput!) {
    gameInstallationProgress(input: $input) {
      progress
    }
  }
`;

export const gameSuggestionsGQL = gql`
  query GameSuggestions($input: GameSuggestionsInput!) {
    gameSuggestions(input: $input) {
      id
      labels
      title
    }
  }
`;
